
import { Switch } from "@/components/ui/switch";
import { Award } from "lucide-react";

interface FilterCreditPointsProps {
  hasCreditPoints: boolean;
  onToggle: () => void;
}

const FilterCreditPoints = ({ hasCreditPoints, onToggle }: FilterCreditPointsProps) => {
  return (
    <div className="flex items-center justify-between rounded-md p-3 border border-medihub-midPurple/20 bg-white shadow-sm hover:shadow-md transition">
      <div className="flex items-center gap-2">
        <Award className="h-5 w-5 text-medihub-accent" />
        <span className="text-sm font-medium">Csak akkreditált események</span>
      </div>
      <Switch
        checked={hasCreditPoints}
        onCheckedChange={onToggle}
        className="data-[state=checked]:bg-medihub-accent"
      />
    </div>
  );
};

export default FilterCreditPoints;
